import HeroContent from "../components/landing/HeroContent";
import Projects from "../components/project/Projects";
import FeedbackBanner from "../components/landing/FeedbackBanner";

function AllProjects() {
  return (
    <section>
      <HeroContent />
      <Projects />
      <FeedbackBanner />
    </section>
  );
}

export default AllProjects;
